export const Urls = {
    GetMepPortSummaryTotalEmissions: "MepSummary/GetMepPortSummaryTotalEmissions",
    GetMepEmissionsByPorts: "MepSummary/GetMepEmissionsByPorts",
    GetMepPortSummaryVesselsByPort: "MepSummary/GetMepPortSummaryVesselsByPort",
    GetMepSummaryVesselStatistics: "MepSummary/GetMepSummaryVesselStatistics",
    GetMepPortSummaryEmission: "MepSummary/GetMepPortSummaryEmission"
}